import { pluralize } from "@entrilia/shared/utilities/stringHelper";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import ArrowRightRoundedIcon from "@mui/icons-material/ArrowRightRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import RemoveCircleRoundedIcon from "@mui/icons-material/RemoveCircleRounded";
import { Box, Button, CircularProgress, Collapse, Stack, Typography } from "@mui/material";
import { useState } from "react";
import type { ChatStep, LastStepState } from "../chatState";

interface Props {
  steps: ChatStep[];
  lastStepState?: LastStepState;
}

const StepIcon = ({ state }: { state: LastStepState | undefined }) => {
  if (state === "Running") {
    return <CircularProgress size={20} />;
  }
  if (state === "Interrupted") {
    return <RemoveCircleRoundedIcon color="disabled" />;
  }
  return <CheckCircleRoundedIcon color="success" />;
};

const ChatSteps = ({ steps, lastStepState }: Props) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <Box>
      <Button
        variant="text"
        color="secondary"
        startIcon={expanded ? <ArrowDropDownRoundedIcon /> : <ArrowRightRoundedIcon />}
        onClick={() => setExpanded((prev) => !prev)}
      >
        {steps.length} {pluralize("step", steps.length)}
      </Button>
      <Collapse in={expanded}>
        <Stack spacing={1.5} sx={{ borderLeft: 1, borderColor: "divider", ml: 1.5, mt: 1, pl: 2, py: 0.5 }}>
          {steps.map((step, index) => (
            <Stack key={step.sequence} direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
              <StepIcon state={index === steps.length - 1 ? lastStepState : undefined} />
              <Typography>{step.text.replace(/…$/, "")}</Typography>
            </Stack>
          ))}
        </Stack>
      </Collapse>
    </Box>
  );
};

export default ChatSteps;
